import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { Notify } from 'notiflix';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: UntypedFormGroup;
  submitted = false;
  isLoading = false;
  showPassword = false;
  showConfirmPassword = false;
  resetToken: string | null = null;

  constructor(
    private _fb: UntypedFormBuilder,
    private _apis: ApiService,
    private _rs: Router,
    private _ar: ActivatedRoute
  ) {
    this.resetPasswordForm = this._fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    // Get token from URL query params
    this._ar.queryParams.subscribe((params) => {
      this.resetToken = params['token'];
      if (!this.resetToken) {
        Notify.failure('Invalid reset link!');
        setTimeout(() => this._rs.navigate(['/login']), 2000);
      }
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.resetPasswordForm.invalid) return;

    // Check if passwords match
    if (
      this.resetPasswordForm.value.password !==
      this.resetPasswordForm.value.confirmPassword
    ) {
      Notify.failure('Passwords do not match!');
      return;
    }

    this.isLoading = true;
    const payload = {
      token: this.resetToken,
      password: this.resetPasswordForm.value.password,
    };

    this._apis.resetPassword(payload).subscribe(
      (res) => {
        this.isLoading = false;
        Notify.success('Password reset successfully!');
        setTimeout(() => this._rs.navigate(['/login']), 2000);
      },
      (err) => {
        this.isLoading = false;
        const errorMsg =
          err?.error?.error ||
          'Failed to reset password. Please try again.';
        Notify.failure(errorMsg);
      }
    );
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
}
